module.exports = __webpack_public_path__ + "img/01.2ea2e76b.jpg";